var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"preloader"},[_c('div',{staticClass:"preloader__box"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }